import { z } from 'zod';

export const sectorSchema = z.object({
  name: z.string().min(2).max(100),
  code: z.string().min(2).max(50).regex(/^[a-z0-9-]+$/, 'Code must be lowercase and use only letters, numbers, and dashes'),
  description: z.string().max(255).optional().nullable(),
  isActive: z.boolean().optional(),
  isDefault: z.boolean().optional(),
});

export const taskTemplateSchema = z.object({
  sectorId: z.number().int().positive(),
  group: z.enum(['internalSystems', 'companyWide', 'branchServices']),
  title: z.string().min(1).max(255),
  code: z.string().min(2).max(80).regex(/^[a-z0-9-]+$/, 'Code must be lowercase and use only letters, numbers, and dashes'),
  defaultStatus: z.enum(['Not Started', 'In Progress', 'On Hold', 'Completed']).optional(),
  icon: z.string().max(32).optional().nullable(),
  sortOrder: z.number().int().min(0).optional(),
  isRequired: z.boolean().optional(),
  isActive: z.boolean().optional(),
  fieldsSchema: z.any().optional().nullable(),
});


